// VenueBanner — small horizontal card showing the current venue.
// Ported from design-canon/project/src/screens-logger.jsx lines 232-245.
//
// 64px square photo on the left (with pin badge) + venue name/meta on the right.
// On the drink-logger this sits between TopBar and the drink-tile grid.

import type { ReactElement } from 'react'
import { Icon } from './Icon'

export type VenueBannerProps = {
  name: string
  /** Either a venue 'kind' like "bar · cocktail" or a city — short subtitle. */
  subtitle?: string | null
  /** Count of drinks logged at this venue (this stop). */
  hereCount: number
  /** Count of drinks logged tonight in total. */
  tonightCount: number
  /** Optional photo url (R2 publicUrl, etc). When missing we fall back to a tint. */
  photoUrl?: string | null
  /** Tint color used when no photo. */
  tint?: string
}

export function VenueBanner({
  name,
  subtitle,
  hereCount,
  tonightCount,
  photoUrl,
  tint = 'var(--orange)',
}: VenueBannerProps): ReactElement {
  const photoStyle: React.CSSProperties = photoUrl
    ? {
        background: `linear-gradient(110deg, ${tint} 0% 38%, rgba(0,0,0,0) 90%), url(${photoUrl}) 60% 40%/cover, ${tint}`,
      }
    : { background: tint }

  const here = `${hereCount} here`
  const tonight = `${tonightCount} tonight`
  const sub = subtitle ? `${subtitle} · ${here} · ${tonight}` : `${here} · ${tonight}`

  return (
    <div className="venue-banner" data-testid="venue-banner">
      <div className="venue-banner-img" style={photoStyle}>
        <span className="venue-banner-pin">
          <Icon name="pin" size={16} color="var(--paper)" />
        </span>
      </div>
      <div className="venue-banner-text">
        <div className="eyebrow" style={{ fontSize: 10 }}>
          now at
        </div>
        <div className="venue-banner-name" data-testid="venue-banner-name">
          {name}
        </div>
        <div className="body-sm muted" style={{ fontSize: 12 }}>
          {sub}
        </div>
      </div>
    </div>
  )
}
